import { render, staticRenderFns } from "./Merger.vue?vue&type=template&id=ff7253da&"
import script from "./Merger.vue?vue&type=script&lang=ts&"
export * from "./Merger.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports